"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDateTimeFormatter = void 0;
var _dateTimeFormatInternal = require("./dateTimeFormatInternal");
var _xmAdmin = require("../locale-data/date-time-format/constructors/lsl/xm-admin");
var createDateTimeFormatter = exports.createDateTimeFormatter = function createDateTimeFormatter(locale) {
  var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'America/Denver';
  return (0, _dateTimeFormatInternal.createDateTimeFormatterInternal)(locale, (0, _xmAdmin.getDateTimeFormat)(locale), timezone);
};
//# sourceMappingURL=xm-admin.js.map